import { Custom } from "components";
import { useApp, useTheme } from "contexts";
import { useMemo } from "react";

export type GuestType = {
  first_name: string;
  email: string;
};

type Props = {
  current: GuestType;
  onBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Fields = ({ current, onBlur, onChange }: Props) => {
  const { t } = useApp();
  const { theme } = useTheme();

  // Only computed once on initial render
  const isEmailDisabled = useMemo(() => !!current?.email, []);
  const isNameDisabled = useMemo(() => !!current?.first_name, []);

  return (
    <>
      <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
        {t.label.email}
      </Custom.Typography>
      <Custom.TextField
        type="email"
        name="email"
        required
        disabled={isEmailDisabled}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={t.placeholder.email}
        label={t.label.email}
        value={current.email}
      />

      <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
        {t.label.preffered_name}
      </Custom.Typography>
      <Custom.TextField
        name="first_name"
        required
        disabled={isNameDisabled}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={t.placeholder.preffered_name}
        label={t.label.preffered_name}
        value={current.first_name}
      />
    </>
  );
};
